<template>
  <OptionsMenuModal modal-id="options-dialog" :title="$t('options.options')" :has-pro="proOptions.length > 0">
    <OptionsMenuRow
      v-for="option in standardOptions"
      :key="option.type"
      :icon="option.icon"
      :label="option.name"
      @select="option.action"
    />
    <template #pro>
      <OptionsMenuRow
        v-for="option in proOptions"
        :key="option.type"
        :icon="option.icon"
        :label="option.name"
        pro
        @select="option.action"
      />
    </template>
  </OptionsMenuModal>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { OptionItem } from '../../utils/models/OptionItem';
import OptionsMenuModal from '../components/options_menu/OptionsMenuModal.vue';
import OptionsMenuRow from '../components/options_menu/OptionsMenuRow.vue';

// The planner's Options menu. Same look as the map Options dialog (MapOptionsDialog): standard
// options first, PRO+ tools grouped under their own label.
export default defineComponent({
  name: 'Options',
  components: { OptionsMenuModal, OptionsMenuRow },
  props: {
    options: {
      type: Array as PropType<OptionItem[]>,
      required: true
    }
  },
  setup(props) {
    const standardOptions = computed(() => props.options.filter((option) => !option.isPro));
    const proOptions = computed(() => props.options.filter((option) => option.isPro));

    return {
      standardOptions,
      proOptions
    };
  }
});
</script>
